import React from 'react';
import { WelcomeDialogs } from '../../screens/general/my-activities/welcome-tutorials/WelcomeDialogs';
import { PageHelpProvider } from '../page-help/PageHelpContext';
import { ChatUnreadProvider } from '../chat/ChatUnreadContext';
import { DrawerContent } from './app-drawer/DrawerContent';
import { LoginAgainDialog } from './LoginAgainDialog';

interface Props {
  isTokenExpired: boolean;
}

const CampfireAppShellComp = ({ isTokenExpired }: Props) => (
  <PageHelpProvider>
    <ChatUnreadProvider>
      <WelcomeDialogs />
      <DrawerContent />
      <LoginAgainDialog open={isTokenExpired} />
    </ChatUnreadProvider>
  </PageHelpProvider>
);

export default CampfireAppShellComp;
